export default {
  reportData: null,
  isLoadingReportData: false,
  isExportingReport: false,
};
